<app-navbar></app-navbar>

<div class="expert-container">
  <div class="cards d-flex">
    <div class="card" *ngFor="let blog of blogs" (click)="openBlog(blog)">
      <div class="img-wrap">
  <img [src]="blog.image" alt="" (error)="onImgError($event)">
</div>

      <div class="data">
        <!-- ✅ keep same element names as static -->
        <h5>{{ blog.title }}</h5>
        <p>{{ getExcerpt(blog.content, 120) }}</p>
      </div>
    </div>
  </div>

  <!-- ✅ SHOW MORE BUTTON (pagination) -->
  <div class="show-more-wrap" *ngIf="!loadingBlogs && hasMore">
    <button class="common-button show-more-btn" (click)="loadMore()" [disabled]="loadingMore">
      {{ loadingMore ? 'Loading...' : 'Show More' }}
    </button>
  </div>
</div>

<!-- FULL SCREEN POPUP (same as before) -->
<div class="blog-popup-overlay" *ngIf="showBlogPopup">
  <div class="blog-popup">

    <div class="popup-header">
      <button class="back-btn" (click)="closeBlogPopup()">
        <i class="bi bi-arrow-left"></i>
        <span>Back</span>
      </button>

      <div class="header-meta" *ngIf="selectedBlogDetail">
        <p class="category">
          {{ selectedBlogDetail?.mainCategory?.name }}
          <span class="dot">•</span>
          {{ selectedBlogDetail?.subCategory?.name }}
        </p>
      </div>

      <button class="close-btn" (click)="closeBlogPopup()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="popup-body">
      <div class="detail-loader" *ngIf="loadingBlogDetail">
        <p>Loading blog...</p>
      </div>

      <ng-container *ngIf="!loadingBlogDetail && selectedBlogDetail">
        <div class="hero">
          <img class="hero-img" [src]="selectedBlogDetail.image" alt="blog" (error)="onImgError($event)" />
        </div>

        <div class="content">
          <h1 class="title">{{ selectedBlogDetail.title }}</h1>

          <div class="meta-row">
            <p class="author">
              Written by:
              <strong>
                {{ selectedBlogDetail?.createdBy?.firstName }} {{ selectedBlogDetail?.createdBy?.lastName }}
              </strong>
            </p>
            <p class="date">
              {{ selectedBlogDetail.createdAt | date:'MMMM d, y' }}
            </p>
          </div>

          <div class="tags" *ngIf="selectedBlogDetail.tags?.length">
            <span class="tag" *ngFor="let t of selectedBlogDetail.tags">#{{ t }}</span>
          </div>

          <div class="desc" *ngIf="selectedBlogDetail.metaDescription">
            {{ selectedBlogDetail.metaDescription }}
          </div>

          <div class="blog-content">
            {{ selectedBlogDetail.content }}
          </div>
        </div>
      </ng-container>
    </div>

  </div>
</div>

<app-footer></app-footer>
